import { z } from "zod"
import { adapterConfig } from "./adapter"
import { SupportedRegions } from "@nova/constants"
import { transferable } from "./transferable"

export const transferNaming = z.object({
    projectName: z.string().optional(),
    projectCreatedAt: z.string().optional(),
    ocfaName: z.boolean().optional(),
    perimeterArea: z.string().optional(),
    imageType: z.string().optional(),
})

export type TransferNaming = z.infer<typeof transferNaming>

export const transferPayload = z.object({
    destination: adapterConfig,
    transfer: z.array(transferable),
    pathPrefix: z.string(),
    orgId: z.string(),
    projectId: z.string(),
    region: z.enum(SupportedRegions),
    userId: z.string(),
    naming: transferNaming.optional(),
    relatedEntityIds: z.array(z.string()).optional(),
})

export type TransferPayload = z.infer<typeof transferPayload>
